import PropTypes from 'prop-types';
// material
import { Box } from '@material-ui/core';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }) {
  return <Box component="img" src="/static/cargills-agri-logo03.png" sx={{ width: 200, height: 90, marginLeft: 3, ...sx }} />;
}
